import React from 'react';
import Hero from '../components/Hero';
import WhyTrustUs from '../components/WhyTrustUs';
import HowWeWork from '../components/HowWeWork';
import HomeServices from '../components/HomeServices';
import SEO from '../components/SEO';

const Home = () => {
    const structuredData = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Avenis Global',
        url: 'https://avenisglobal.com',
        logo: 'https://avenisglobal.com/logo-512x512.png',
        description:
            'Avenis Global specializes in e-commerce partnerships, wholesale solutions, and digital marketing strategies.',
        address: {
            '@type': 'PostalAddress',
            addressCountry: 'US',
        },
        contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'customer service',
            url: 'https://avenisglobal.com/contact',
        },
        sameAs: [],
        foundingDate: '2024',
        industry: 'E-commerce and Digital Marketing',
        services: [
            'Amazon Wholesale',
            'Brand Partnerships',
            'E-commerce Consulting',
            'Digital Marketing',
            'Wholesale Solutions',
        ],
    };

    return (
        <div className="home">
            <SEO
                title="Avenis Global | Brand Partnerships & Wholesale Solutions"
                description="Avenis Global specializes in e-commerce partnerships, wholesale solutions, and digital marketing strategies. Partner with us for Amazon wholesale, brand partnerships, and comprehensive digital solutions."
                keywords="Amazon wholesale, e-commerce partnerships, brand partnerships, wholesale solutions, digital marketing, Amazon seller, wholesale business, e-commerce consulting, brand management, digital solutions"
                url="https://avenisglobal.com/"
                structuredData={structuredData}
            />
            <Hero />
            <WhyTrustUs />
            <HowWeWork />
            <HomeServices />
        </div>
    );
};

export default Home;
